import { useTranslation } from 'react-i18next';

import {
	AccordionContent,
	AccordionItem,
	AccordionTrigger
} from '@/components/Accordion';

function FaqItem({ question, answer, value }) {
	const { t } = useTranslation();

	const parseAnswer = answerArray => (
		<div className="flex flex-col gap-2 text-xs font-normal leading-5 text-black lg:text-sm">
			{answerArray.map((item, ix) => {
				if (typeof item === 'string') {
					return <p key={ix}>{t(item)}</p>;
				}
				if (item?.type === 'ordered') {
					return (
						<ol className="list-decimal pl-5" key={ix}>
							{item.items.map((listItem, listIdx) => (
								<li key={listIdx}>{t(listItem)}</li>
							))}
						</ol>
					);
				}
				if (item?.type === 'unordered') {
					return (
						<ul className="list-disc pl-5" key={ix}>
							{item.items.map((listItem, listIdx) => (
								<li key={listIdx}>{t(listItem)}</li>
							))}
						</ul>
					);
				}
				return null;
			})}
		</div>
	);

	return (
		<AccordionItem key={value} value={value}>
			<AccordionTrigger className="h-auto items-center gap-4 py-4 data-[state=open]:pb-6 data-[state=open]:text-red md:py-6">
				<span className="text-sm font-semibold leading-6 md:text-base md:leading-7">
					{question}
				</span>
			</AccordionTrigger>
			<AccordionContent className="pb-8 md:pb-12">
				{Array.isArray(answer) ? parseAnswer(answer) : answer}
			</AccordionContent>
		</AccordionItem>
	);
}

export default FaqItem;
